<h5>Operazioni del mese</h5>
<div class="operations-grid-container">
    <ng-container *ngFor="let item of kpis">
        <div class="operations-grid-item">
            <h3 class="m-0">{{ countersType === 'premium' ?  (item?.key | currency: 'EUR') : item?.key }}</h3>
            <p class="m-0">{{item?.label | uppercase}}</p>
        </div>
    </ng-container>
</div>